export const UPDATE_LOAN_FORM_DATA = "UPDATE_LOAN_FORM_DATA";
export const updateLoanFormData = formData => ({
  type: UPDATE_LOAN_FORM_DATA,
  formData
});

export const CLEAR_LOAN_FORM_DATA = "CLEAR_LOAN_FORM_DATA";
export const clearLoanFormData = () => ({
  type: CLEAR_LOAN_FORM_DATA
});
